export default "__VITE_ASSET__Dwl809AH__"